import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractRefundInvoiceEmailTemplate.List.IRequest;
type Response = Api.Core.ContractRefundInvoiceEmailTemplate.List.IResponse;
type Headers = Api.Core.ContractRefundInvoiceEmailTemplate.List.IHeaders;
const url = '/api/Management/ContractRefundInvoiceEmailTemplate';
export default async function contractRefundInvoiceEmailTemplateListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
